<template>
    <div :class="[{'focused-item':focused}, 'merge-button-container']">

        <el-tooltip placement="top-start"
                    :content="tooltipContent"
                    :show-after="5">

            <div id="merge-segments"
                 :class="['img-button-container', 'merge-button', { 'disabled': disabled }]"
                 @click="mergeSegment">
                <span class="material-symbols-outlined">
                    compress
                </span>
            </div>


        </el-tooltip>

    </div>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';
    import { useI18n } from 'vue-i18n'
    import { shortcuts } from '@/utils/shortcuts';
    import { DocumentType } from '@/models/DocumentType';

    export default defineComponent({
        props: {
            focused: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            },
            documentType: {
                type: Number,
                default: DocumentType.Docx
            },
        },
        setup() {
            const { t } = useI18n()
            return { t }
        },
        computed: {
            tooltipContent(): string {
                if (this.disabled) {
                    return this.getDisabledTooltip();
                }
                return shortcuts.getTooltipTranslated(this.t, shortcuts.merge);
            }
        },
        methods: {
            getDisabledTooltip(): string {
                switch (this.documentType) {
                    case DocumentType.Xlsx:
                        return this.t('mergeSegment.cannotMergeDifferentCells') as string;
                    case DocumentType.Pptx:
                        return this.t('mergeSegment.cannotMergeDifferentTextBlocks') as string;
                    case DocumentType.Idml:
                        return this.t('mergeSegment.cannotMergeDifferentStories') as string;
                    default:
                        return this.t('mergeSegment.cannotMergeDifferentParagraphs') as string;
                }
            },
            mergeSegment() {
                if (this.disabled) return;
                this.$emit('merge');
            }
        }

    });
</script>

<style lang="scss" scoped>

    .merge-button-container {
        height: 1px;
        width: 30%;
        position: absolute;
        opacity: 0;
        transition: opacity 0.5s ease;

        &:hover {
            opacity: 0.6;
        }
    }

    .focused-item.merge-button-container {
        opacity: 1;
    }

    .merge-button {
        position: absolute;
        top: -24px;
        left: 10px;
        width: 48px;
        background-color: white;
        border-radius: 24px;
        box-shadow: 1px 3px 5px rgba(0, 0, 0, 0.1);

        &.disabled {
            opacity: 0.3;
            cursor: not-allowed;
        }
    }
</style>